import React, { useEffect } from 'react';
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Header from 'shared/component/header';
import { useStyles } from './style';
import { useAuth } from 'hook/auth';
import MenuSidebar from 'route';
import { Link } from 'react-router-dom';
import AvatarSidebar from '../sidebar/components/avatar';
import appColors from 'utils/appColors';
import usePersistedState from 'hook/usePersistedState';
import { useConfig } from 'hook/config';

const NewSidebar = ({
  title = '',
  route,
  specificRoute,
  backArrow = false,
  handleDateChange = () => {},
  calendarWeek = true,
  calendarDay = true,
  calendarRange = false,
  showToday = false,
  calendarMonth = false,
  showHeader = true,
  handleCleanCheckbox = null,
  startNull = null,
  startToday = false,
  newTittleContainerStyle = false,
  titleContainerStyle = {},
}) => {
  const classes = useStyles();
  const { config, setConfig } = useConfig();

  const { userLogged } = useAuth();

  const [open, setOpen] = usePersistedState('openSidebar', true);

  const handledrawerPaper = () => {
    setOpen(true);
    setConfig({ ...config, open: true });
  };

  const handledrawerPaperClose = () => {
    setOpen(false);
    setConfig({ ...config, open: false });
  };

  useEffect(() => {
    setConfig((prev) => {
      if (prev.open === open) return prev;
      return { ...prev, open };
    });
  }, [open, setConfig]);

  return (
    <>
      <CssBaseline />
      <AppBar
        color="inherit"
        elevation={0}
        className={clsx(
          classes.appBar,
          open ? classes.appBarOpen : classes.appBarCollapsed
        )}
      >
        <Toolbar
          dense
          disableGutters={false}
          style={{
            backgroundColor: appColors.BACKGROUND_COLOR,
            color: appColors.GRAY_TEXT_COLOR,
            minHeight: 52,
            paddingLeft: 12,
            paddingRight: 16,
          }}
        >
          {showHeader && (
            <Header
              title={title}
              route={route}
              specificRoute={specificRoute}
              backArrow={backArrow}
              handleDateChange={handleDateChange}
              calendarWeek={calendarWeek}
              calendarRange={calendarRange}
              showToday={showToday}
              calendarMonth={calendarMonth}
              calendarDay={calendarDay}
              open={open}
              startNull={startNull}
              startToday={startToday}
              newTittleContainerStyle={newTittleContainerStyle}
              titleContainerStyle={titleContainerStyle}
            />
          )}
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={classes.drawer}
        classes={{
          paper: clsx({
            [classes.drawerPaper]: open,
            [classes.drawerPaperClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <div className={classes.container_image}>
            {userLogged && open ? (
              <div className="flex justify-center">
                <img
                  alt=""
                  src={userLogged?.company?.image_url}
                  className="w-28 h-28"
                />
              </div>
            ) : (
              <div className={classes.sideImage}></div>
            )}
          </div>
        </div>

        <div
          className={clsx(
            classes.toggleRow,
            open ? classes.toggleRowOpen : classes.toggleRowCollapsed
          )}
        >
          {open ? (
            <div className={classes.iconSideContainer}>
              <IconButton
                id="abrefechamenulateral"
                style={{
                  color: 'white',
                  backgroundColor: '#003366',
                  width: 20,
                  height: 20,
                  overflow: 'inherit',
                  marginLeft: -13,
                  position: 'absolute',
                }}
                onClick={handledrawerPaperClose}
              >
                <KeyboardArrowLeftIcon />
              </IconButton>
            </div>
          ) : (
            <IconButton
              style={{
                color: 'white',
                backgroundColor: '#003366',
                width: 28,
                height: 28,
              }}
              onClick={handledrawerPaper}
            >
              <KeyboardArrowRightIcon />
            </IconButton>
          )}
        </div>
        {open ? (
          <Link
            to="/profile"
            style={{
              textDecoration: 'none',
              color: 'black',
            }}
          >
            <div className={classes.profile}>
              <AvatarSidebar name={userLogged?.name} data={userLogged} />
            </div>
          </Link>
        ) : (
          <Link
            to="/profile"
            style={{
              textDecoration: 'none',
            }}
          >
            <div className={clsx(classes.profile, classes.profileCollapsed)}>
              <AvatarSidebar data={userLogged} />
            </div>
          </Link>
        )}
        <Divider style={{ marginBottom: 20 }} />
        <div className="overflow-y-auto flex-1 overflow-x-hidden ">
          <MenuSidebar handleCleanCheckbox={handleCleanCheckbox} />
        </div>
      </Drawer>
    </>
  );
};
export default NewSidebar;
